// localStorage.js
export const getLocalState = (key)=> {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const setLocalState = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    localStorage.setItem(key, serializedState);
  } catch {
    // ignore write errors
  }
};

export const removeLocalState = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore write errors
  }
}
